import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  }
})

// Database types (these will be generated by Supabase CLI in production)
export type Database = {
  public: {
    Tables: {
      trips: {
        Row: {
          id: string
          name: string
          description: string | null
          start_date: string | null
          end_date: string | null
          is_public: boolean
          created_by: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          description?: string | null
          start_date?: string | null
          end_date?: string | null
          is_public?: boolean
          created_by: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          description?: string | null
          start_date?: string | null
          end_date?: string | null
          is_public?: boolean
          created_by?: string
          created_at?: string
          updated_at?: string
        }
      }
      trip_members: {
        Row: {
          id: string
          trip_id: string
          user_id: string | null
          role: 'owner' | 'member'
          member_type: 'full_member' | 'guest'
          guest_name: string | null
          guest_email: string | null
          guest_session_id: string | null
          guest_access_token: string | null
          departure_time: string | null
          departure_location: string | null
          joined_at: string
        }
        Insert: {
          id?: string
          trip_id: string
          user_id?: string | null
          role?: 'owner' | 'member'
          member_type?: 'full_member' | 'guest'
          guest_name?: string | null
          guest_email?: string | null
          guest_session_id?: string | null
          guest_access_token?: string | null
          departure_time?: string | null
          departure_location?: string | null
          joined_at?: string
        }
        Update: {
          id?: string
          trip_id?: string
          user_id?: string | null
          role?: 'owner' | 'member'
          member_type?: 'full_member' | 'guest'
          guest_name?: string | null
          guest_email?: string | null
          guest_session_id?: string | null
          guest_access_token?: string | null
          departure_time?: string | null
          departure_location?: string | null
          joined_at?: string
        }
      }
      waypoints: {
        Row: {
          id: string
          trip_id: string
          name: string
          latitude: number | null
          longitude: number | null
          order_index: number | null
          notes: string | null
          created_at: string
        }
        Insert: {
          id?: string
          trip_id: string
          name: string
          latitude?: number | null
          longitude?: number | null
          order_index?: number | null
          notes?: string | null
          created_at?: string
        }
        Update: {
          id?: string
          trip_id?: string
          name?: string
          latitude?: number | null
          longitude?: number | null
          order_index?: number | null
          notes?: string | null
          created_at?: string
        }
      }
      trip_invite_codes: {
        Row: {
          id: string
          trip_id: string
          invite_code: string
          created_by: string
          expires_at: string
          is_active: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          trip_id: string
          invite_code: string
          created_by: string
          expires_at: string
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          trip_id?: string
          invite_code?: string
          created_by?: string
          expires_at?: string
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
      }
      trip_invitations: {
        Row: {
          id: string
          trip_id: string
          email: string
          role: 'owner' | 'member'
          member_type: 'full_member' | 'guest'
          invited_by: string
          personal_message: string | null
          invitation_token: string
          status: 'pending' | 'accepted' | 'declined' | 'expired'
          expires_at: string
          accepted_at: string | null
          declined_at: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          trip_id: string
          email: string
          role?: 'owner' | 'member'
          member_type?: 'full_member' | 'guest'
          invited_by: string
          personal_message?: string | null
          invitation_token?: string
          status?: 'pending' | 'accepted' | 'declined' | 'expired'
          expires_at?: string
          accepted_at?: string | null
          declined_at?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          trip_id?: string
          email?: string
          role?: 'owner' | 'member'
          member_type?: 'full_member' | 'guest'
          invited_by?: string
          personal_message?: string | null
          invitation_token?: string
          status?: 'pending' | 'accepted' | 'declined' | 'expired'
          expires_at?: string
          accepted_at?: string | null
          declined_at?: string | null
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
